import React from "react";
import imgFour from "../assets/img/hero5.png";

export default function Konseling() {
  return (
    <>
      <div className="container my-5 font-link">
        <div className="row">
          <div className="col-lg-6 text-center">
            <img className="w-80" src={imgFour} alt=""></img>
          </div>
          <div className="col-lg-6">
            <div className="pt-4 pe-5 mt-4 text-hero p-5">
              <h1>
                Konseling <span>by MS Wellbeing Center</span>
              </h1>
              <h2 className="pt-3 pb-2">
                Pentingnya Mengetahui Kesehatan Mental Anda
              </h2>
              <p>
                Anda dapat berkonsultasi langsung dari psikolog professional
                yang telah kami sediakan. Dalam layanan Healthybyte ini
                menyediakan berbagai paket yang cocok untuk kamu. Dalam paket
                tersebut, anda bisa memilih psikolog yang dapat menyesuaikan
                jadwal anda. Jangan lupa set jadwal kamu ya setelah memesan
                paket yang telah kamu pilih sehingga kamu psikolog dapat
                mengetauhi jadwal yang telah kamu pilih. Semoga paket ini dapat
                membantu kamu menyelesaikan permasalahan dan juga membuat kamu
                feel better ya!
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="pt-2 pb-5">
        <div className="container">
          <h3 className="mb-5 text-center">Apa Kata Mereka</h3>

          <div className="row justify-content-center px-3 py-4">
            <div className="col-md-4">
              <div className="testimonial">
                <div className="testi-img d-flex justify-content-center">
                  <img
                    className=""
                    src="https://upload.wikimedia.org/wikipedia/commons/9/9e/Placeholder_Person.jpg"
                    alt=""
                  />
                </div>

                <div className="text-center">
                  <p className="testi-name pt-2">
                    Putri <br />
                    <span> Pekerja | 25 Tahun </span>
                  </p>
                </div>

                <div className="text-center pb-3">
                  <p className="px-4 pb-3">
                    ketika saya sedang mengalami stres karena kesibukan kerjaan
                    saya, saya direkomendasikan teman saya untuk melakukan
                    konsultasi di healthbyte disini. fitur memilih jadwal
                    konsultasi tersebut sangat memudahkan saya di tengah
                    kepadatan saya. selain itu, psikolog disini baik dan ramah
                    sehingga saya nyaman untuk berkonsultasi. harga paket yang
                    ditawarkan juga terbilang ramah di kantong.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="testimonial">
                <div className="testi-img d-flex justify-content-center">
                  <img
                    className=""
                    src="https://upload.wikimedia.org/wikipedia/commons/9/9e/Placeholder_Person.jpg"
                    alt=""
                  />
                </div>

                <div className="text-center">
                  <p className="testi-name pt-2">
                    Putri <br />
                    <span> Pekerja | 25 Tahun </span>
                  </p>
                </div>

                <div className="text-center pb-3">
                  <p className="px-4 pb-3">
                    ketika saya sedang mengalami stres karena kesibukan kerjaan
                    saya, saya direkomendasikan teman saya untuk melakukan
                    konsultasi di healthbyte disini. fitur memilih jadwal
                    konsultasi tersebut sangat memudahkan saya di tengah
                    kepadatan saya. selain itu, psikolog disini baik dan ramah
                    sehingga saya nyaman untuk berkonsultasi. harga paket yang
                    ditawarkan juga terbilang ramah di kantong.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="testimonial">
                <div className="testi-img d-flex justify-content-center">
                  <img
                    className=""
                    src="https://upload.wikimedia.org/wikipedia/commons/9/9e/Placeholder_Person.jpg"
                    alt=""
                  />
                </div>

                <div className="text-center">
                  <p className="testi-name pt-2">
                    Putri <br />
                    <span> Pekerja | 25 Tahun </span>
                  </p>
                </div>

                <div className="text-center pb-3">
                  <p className="px-4 pb-3">
                    ketika saya sedang mengalami stres karena kesibukan kerjaan
                    saya, saya direkomendasikan teman saya untuk melakukan
                    konsultasi di healthbyte disini. fitur memilih jadwal
                    konsultasi tersebut sangat memudahkan saya di tengah
                    kepadatan saya. selain itu, psikolog disini baik dan ramah
                    sehingga saya nyaman untuk berkonsultasi. harga paket yang
                    ditawarkan juga terbilang ramah di kantong.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
